import ArtifactGroupType from "../base/ArtifactGroupType";

const StringsOfTheAncients = {
  id: '98',
  name: 'Strings Of The Ancients',
  icon: 'StringsOfTheAncients',
  groupIcon: 'FoundationsOfCivilization',
  type: ArtifactGroupType.FOUNDATIONS_OF_CIVILIZATION,
  power: 10,
  gameId: 'StringsOfTheAncients'
};

export default StringsOfTheAncients;
